const env = process.env.NODE_ENV
// 开发环境运行命令：npm run serve
// 生产环境打包命令：npm run build
// 测试环境打包命令：npm run test
const IP = {
  development: { // 本地开发环境
    baseIP: 'http://ftalk-api.soullions.com' // test
  },
  production: { // 生产环境
    baseIP: 'http://ftalk-api.fengyongtech.com'
  },
  test: { // 测试环境
    baseIP: 'http://ftalk-api.soullions.com'
  }
}
export default IP[env]
